import type { currentCartV2 } from '@wix/ecom';

export const getCatalogAppIds = (
  items?: { source?: currentCartV2.ItemSource }[],
): string => {
  return getMappedUniqueList(
    items,
    ({ source }) => source?.catalogReference?.appId,
  );
};

export const getItemTypes = (
  items?: { attributes?: { itemType?: currentCartV2.ItemType } }[],
): string => {
  return getMappedUniqueList(
    items,
    ({ attributes }) => attributes?.itemType?.preset,
  );
};

export const getItemsCount = (
  items?: { quantityInfo?: currentCartV2.ItemQuantityInfo }[],
): number => {
  return (
    items?.reduce(
      (count, item) => count + (item.quantityInfo?.confirmedQuantity ?? 0),
      0,
    ) ?? 0
  );
};

function getMappedUniqueList<T>(
  arr: T[] | undefined,
  mapper: (t: T) => string | undefined | null,
): string {
  return getUniques(
    (arr ?? /* istanbul ignore next */ [])
      .map(mapper)
      .filter(isDefined) as string[],
  ).toString();
}

const getUniques = (arr: string[]): string[] => {
  return [...new Set([...arr])];
};

const isDefined = <T>(obj: T): boolean => {
  return !!obj;
};
